import { inject, Injectable } from '@angular/core';
import { WindowService } from '@shared/window';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    private windowsService = inject(WindowService);

    clear(): void {
        localStorage.clear();
    }

    getItem(key: string): string | null {
        if (this.windowsService.isBrowser) {
            return localStorage.getItem(key);
        }
        return null;
    }

    key(index: number): string | null {
        if (this.windowsService.isBrowser) {
            return localStorage.key(index);
        }
        return null;
    }

    removeItem(key: string): void {
        if (this.windowsService.isBrowser) {
            localStorage.removeItem(key);
        }
    }

    setItem(key: string, value: string): void {
        if (this.windowsService.isBrowser) {
            localStorage.setItem(key, value);
        }
    }
}
